import { useTabNavigation } from "../../../navigation";

export const useOpenCrypto = () => {
    const nav = useTabNavigation();
    const openCrypto = () => nav.navigate("CryptoScreen");
    return openCrypto;
}